// Module
var code = "<button id=\"scroll-top\" class=\"btn btn-info dont-print\" ng-show=\"scrollY > 120\" ng-click=\"scrollToTop()\" title=\"{{ 'scroll-top' | translate }}\"><i class=\"fa fa-long-arrow-up\"></i></button>";
// Exports
module.exports = code;